import { render, staticRenderFns } from "./BurgerLink.vue?vue&type=template&id=16cbfa0f&scoped=true&"
import script from "./BurgerLink.vue?vue&type=script&lang=js&"
export * from "./BurgerLink.vue?vue&type=script&lang=js&"
import style0 from "./BurgerLink.vue?vue&type=style&index=0&id=16cbfa0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cbfa0f",
  null
  
)

export default component.exports